import styled from 'styled-components';
import { Box, Card, Text } from '@usealloy/component-library';


export const CardContentContainer = styled(Box)`
  align-content: center;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
`;

export const CardContentText = styled(Text)`
  && {
    line-height: var(--cl-line-height-2);
    text-align: center;
  }
`;

export const StyledCard = styled(Card)`
  div:last-child {
    height: 100%;
  };
`;

